export default "__VITE_ASSET__DK2_InyH__"